<template>
  <div>
    <div class="mt-4 w-full flex flex-col sm:flex-row justify-around">
      <template v-for="(category, index) in categories">
        <div class="w-full px-2 mb-4 sm:w-1/3 flex flex-col" :key="index">
          <button
            @click="getProductsByCategory(index)"
            class="products__categories"
            :class="[selected === index ? 'bg-green-500' : 'bg-white']"
          >
            {{ category.name }}
          </button>
          <button class="products__new" @click="goToCreateProduct">
            New Product
          </button>
        </div>
      </template>
    </div>
    <div v-if="selected !== null" class="w-full my-4 text-center">
      <h3>Products of: {{ categories[selected].name }}</h3>
    </div>
    <div class="flex flex-wrap mt-4">
      <template v-for="(product, key) in products">
        <Product
          class="w-full sm:w-1/3"
          :key="key"
          :product="product"
          @delete-product="deleteProduct"
        />
      </template>
      <div
        v-if="selected !== null"
        class="flex w-full sm:w-1/3 justify-center items-center"
      >
        <div class="border-2 border-gray-700 rounded-full py-5 px-8">
          <fa-icon class="text-gray-700" :icon="['fas', 'plus']" size="lg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { allCategories, specificCategory } from '@/services/api/category.js'
import { deleteProduct } from '@/services/api/product.js'
import Product from '@/components/ui/portal/Product.vue'

export default {
  components: {
    Product
  },
  data() {
    return {
      products: [],
      categories: [],
      selected: null
    }
  },
  methods: {
    getProductsByCategory(index) {
      specificCategory(this.categories[index].id).then(response => {
        this.selected = index
        this.products = response.category.products
      })
    },
    deleteProduct(product) {
      const index = this.products.indexOf(product)
      deleteProduct(product.id).then(() => {
        this.products.splice(index, 1)
      })
    },
    goToCreateProduct() {
      this.$router.push({
        name: 'CreateOrUpdateProduct'
      })
    }
  },
  mounted() {
    allCategories().then(response => {
      this.categories = response.categories
    })
  }
}
</script>

<style lang="sass">
.products
  &__categories
    transition: all .2s ease-out
    @apply w-full bg-white rounded-md text-gray-800 font-semibold shadow-md border-b-2 border-green-500
    &:hover
      @apply text-gray-700 border-b-8
  &__new
    width: max-content
    transition: all .2s ease-out
    @apply px-4 bg-white mx-2 my-2 rounded-md text-gray-800 font-semibold shadow-md self-center
    &:hover
      @apply text-white bg-green-500
</style>
